const ChartPlaceholder = ({ title = '', text = 'Ingen data tillgänglig.', variant = 'pie' }) => (
    <div className="chart-wrapper chart-no-data">
        {title && <span>{title}</span>}

        <div className={`chart-placeholder chart-placeholder-${variant}`}>
            <p>{text}</p>
        </div>
    </div>
);

export default ChartPlaceholder;
